"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertMbToBytes = convertMbToBytes;
exports.convertBytesToMb = convertBytesToMb;
exports.validateFileSize = validateFileSize;
exports.getFileContent = getFileContent;
exports.getUploadFileBody = getUploadFileBody;
exports.generateAndDownloadDocument = generateAndDownloadDocument;
exports.getContentTypeFromBase64 = getContentTypeFromBase64;
exports.createObjectUrlFromBase64File = createObjectUrlFromBase64File;
exports.getFilesFromFieldsForUpload = getFilesFromFieldsForUpload;
exports.getRawFilesFromFieldsForUpload = getRawFilesFromFieldsForUpload;
exports.sortFiles = sortFiles;
exports.getDocumentType = getDocumentType;
exports.getInvoiceNumber = getInvoiceNumber;
exports.getFileExtension = getFileExtension;
exports.renameFile = renameFile;
exports.specificFileSubTypes = exports.goToFilePreview = exports.getPreviewPageUrl = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _snakeCase = _interopRequireDefault(require("lodash/snakeCase"));

var _router = _interopRequireDefault(require("next/router"));

var _invoices = require("../../constants/invoices");

var _routes = require("../../constants/routes");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getPreviewPageUrl = function getPreviewPageUrl(_ref) {
  var fileSlug = _ref.fileSlug;
  return "".concat(_routes.FILE_PREVIEW_ROUTE, "?fileSlug=").concat(fileSlug);
};

exports.getPreviewPageUrl = getPreviewPageUrl;

var goToFilePreview = function goToFilePreview(_ref2) {
  var fileSlug = _ref2.fileSlug;
  return _router["default"].push(getPreviewPageUrl({
    fileSlug: fileSlug
  }));
};

exports.goToFilePreview = goToFilePreview;

function convertMbToBytes(value) {
  return value * Math.pow(1024, 2);
}

function convertBytesToMb(value) {
  return value / Math.pow(1024, 2);
}

function validateFileSize(size, maxSize) {
  return size <= maxSize;
}
/**
 * Reads and returns base64 file content
 * @param {File} file
 */


function getFileContent(file) {
  var reader = new FileReader();
  return new Promise(function (done) {
    reader.onload = function (event) {
      done(event.target.result);
    };

    reader.readAsDataURL(file);
  });
}
/**
 * Generates API-compatible file body for upload request
 * @param {File} file
 */


function getUploadFileBody(_x, _x2) {
  return _getUploadFileBody.apply(this, arguments);
}
/**
 * Generates an element to allow downloading the file
 * @param {Object} file
 */


function _getUploadFileBody() {
  _getUploadFileBody = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(file, subType) {
    var name;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            name = file.name;
            _context.next = 3;
            return getFileContent(file);

          case 3:
            _context.t0 = _context.sent;
            _context.t1 = name;
            _context.t2 = subType;
            return _context.abrupt("return", {
              content: _context.t0,
              name: _context.t1,
              subType: _context.t2
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getUploadFileBody.apply(this, arguments);
}

function generateAndDownloadDocument(file) {
  var linkSource = file.content;
  var downloadLink = document.createElement('a');
  var fileName = file.description ? "".concat(file.description, "-").concat(file.name) : file.name;
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.rel = 'noopener';
  downloadLink.click();
}

function getContentTypeFromBase64(base64String) {
  return base64String === null || base64String === void 0 ? void 0 : base64String.substring(base64String.indexOf(':') + 1, base64String.indexOf(';base64'));
}
/**
 *
 * @param {object} file
 */


function base64ToBlob(file) {
  var contentType = getContentTypeFromBase64(file === null || file === void 0 ? void 0 : file.content); // this was totally adapted from here https://stackoverflow.com/a/54466127

  var base64ImageData = file.content;
  var byteCharacters = atob(base64ImageData.substr("data:".concat(contentType, ";base64,").length));
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += 1024) {
    var slice = byteCharacters.slice(offset, offset + 1024);
    var byteNumbers = new Array(slice.length);

    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, {
    type: contentType
  });
}
/**
 *
 * When using this function, don't forget to call URL.revokeObjectURL(blobUrl) to avoid memory leaks.
 */


function createObjectUrlFromBlob(blob) {
  return URL.createObjectURL(blob);
}
/**
 * When using this function, don't forget to call URL.revokeObjectURL(blobUrl) to avoid memory leaks.
 */


function createObjectUrlFromBase64File(file) {
  return createObjectUrlFromBlob(base64ToBlob(file));
}
/**
  Specific file sub types.
  Tiger expects specific sub types for some files.
 */


var specificFileSubTypes = {
  p45Document: 'p45_document',
  form12bb: 'form_12bb'
};
/**
 * Returns an array of objects with the file contents and its description
 * @param {Object} fields
 */

exports.specificFileSubTypes = specificFileSubTypes;

function getFilesFromFieldsForUpload(_x3) {
  return _getFilesFromFieldsForUpload.apply(this, arguments);
}
/**
 * Returns an array of objects with the raw binary file
 * @param {Object} fields
 */


function _getFilesFromFieldsForUpload() {
  _getFilesFromFieldsForUpload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(fields) {
    var subTypes, fileRequests, files;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            subTypes = Object.keys(fields);
            fileRequests = [];
            files = [];
            subTypes.forEach(function (key) {
              // ASSUMPTION: there is only one file per field
              fields[key].forEach(function (file) {
                var request = getUploadFileBody(file, key);
                fileRequests.push(request);
              });
            });
            _context2.next = 6;
            return Promise.all(fileRequests);

          case 6:
            files = _context2.sent;
            return _context2.abrupt("return", files.map(function (file) {
              var defaultSubType = file.subType;
              var subType = defaultSubType in specificFileSubTypes ? specificFileSubTypes[defaultSubType] : (0, _snakeCase["default"])(defaultSubType);
              return _objectSpread(_objectSpread({}, file), {}, {
                subType: subType
              });
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getFilesFromFieldsForUpload.apply(this, arguments);
}

function getRawFilesFromFieldsForUpload(fields) {
  var subTypes = Object.keys(fields);
  var files = [];
  subTypes.forEach(function (key) {
    // ASSUMPTION: there is only one file per field
    fields[key].forEach(function (file) {
      files.push({
        file: file,
        subType: key
      });
    });
  });
  return files.map(function (_ref3) {
    var file = _ref3.file,
        defaultSubType = _ref3.subType;
    var subType = defaultSubType in specificFileSubTypes ? specificFileSubTypes[defaultSubType] : (0, _snakeCase["default"])(defaultSubType);
    return {
      file: file,
      subType: subType
    };
  });
}

function sortFiles(expenses) {
  return expenses.sort(function (a, b) {
    return a.insertedAt > b.insertedAt ? 1 : -1;
  });
}

function getDocumentType(transactionReceipts) {
  return (0, _isEmpty["default"])(transactionReceipts) ? _invoices.documentTypes.PAYROLL_RUN : _invoices.documentTypes.CONTRACTOR;
}

function getInvoiceNumber() {
  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var docType = arguments.length > 1 ? arguments[1] : undefined;
  var countryCode = number.countryCode,
      value = number.value;
  if (!countryCode && !value) return '';
  var invoiceNumber = String(value);
  var prefix = docType === _invoices.documentTypes.CONTRACTOR ? 'TR' : countryCode;
  var fixedLength = 10;
  return "".concat(prefix).concat(invoiceNumber.padStart(fixedLength, '0'));
}
/**
 * Returns file extension based on name
 * @param {File} file
 */


function getFileExtension(file) {
  return file.name.split('.').pop();
}
/**
 * Rename file
 * @param {File} file
 */


function renameFile(file, filename) {
  // This approach do not support IE11
  return new File([file], filename, {
    type: file.type
  });
}